import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, ShieldCheck } from "lucide-react";

export const SiteFooter = () => {
  return (
    <footer className="relative border-t border-white/10 py-12 sm:py-14 bg-[rgba(11,12,14,0.96)]" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <img src="/logo.png" alt="Holdstill Records" className="h-10 w-auto" />
            <p className="mt-3 font-mono-ui text-[11px] tracking-[0.3em] uppercase text-[color:var(--hs-ink-dim)]">
              Music Growth Systems
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 text-sm">
            <a
              href="mailto:info@holdstill.in"
              className="flex items-center gap-2 text-white/80 hover:text-[color:var(--hs-lime)]"
              data-testid="footer-email-link"
            >
              <Mail className="h-4 w-4" /> info@holdstill.in
            </a>
            <a
              href="https://www.instagram.com/holdstill.in"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white/80 hover:text-[color:var(--hs-lime)]"
              data-testid="footer-instagram-link"
            >
              <Instagram className="h-4 w-4" /> @holdstill.in
            </a>
            <Link
              to="/privacy"
              className="flex items-center gap-2 text-white/80 hover:text-[color:var(--hs-lime)]"
              data-testid="footer-privacy-link"
            >
              <ShieldCheck className="h-4 w-4" /> Privacy Policy
            </Link>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-white/35">
            © {new Date().getFullYear()} Holdstill Records. Built by musicians, for the scene. · DPDP Act 2023 compliant —
            data requests: info@holdstill.in
          </p>
          <Link
            to="/crm/login"
            className="font-mono-ui text-[10px] tracking-[0.25em] uppercase text-white/30 hover:text-[color:var(--hs-lime)]"
            data-testid="footer-team-login-link"
          >
            Team Login
          </Link>
        </div>
      </div>
    </footer>
  );
};
